<template>
  <router-view></router-view>
  <overlay-viewer></overlay-viewer>
</template>

<script>
import OverlayViewer from "@/components/OverlayViewer";


export default {
  name: "App",
  components: {
    OverlayViewer
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
